import EventEmitter from "eventemitter3";
import type { ComponentProps } from 'vue-component-type-helpers'


export const event = new EventEmitter<{
  show: [{
    id: keyof typeof import("@/components/modals");
    [key: string]: unknown;
  }]
}>();

export function show<MODAL extends keyof typeof import("@/components/modals")>(id: MODAL, props: ComponentProps<typeof import("@/components/modals")[MODAL]>) {
  event.emit("show", {
    id,
    props,
  });
}
